import React, { useState, useEffect } from 'react';
import { useShop } from './context/ShopContext';
import { Header } from './components/Header';
import { TiltMugViewer } from './components/TiltMugViewer';
import { ProductDetails } from './components/ProductDetails';
import { CartDrawer } from './components/CartDrawer';
import { OrderConfirmation } from './components/OrderConfirmation';
import { FAQ } from './components/FAQ';
import { Footer } from './components/Footer';
import { LegalModal } from './components/LegalModal';
import { AdminDashboard } from './components/admin/AdminDashboard';
import { Check } from 'lucide-react';

export const App: React.FC = () => {
  const { toastMessage } = useShop();
  const [currentRoute, setCurrentRoute] = useState<string>(() => {
    const h = window.location.hash;
    return h || '#/';
  });

  useEffect(() => {
    const handleHashChange = () => {
      setCurrentRoute(window.location.hash || '#/');
      window.scrollTo(0, 0);
    };

    window.addEventListener('hashchange', handleHashChange);
    return () => window.removeEventListener('hashchange', handleHashChange);
  }, []);

  // Route: Admin
  if (currentRoute.startsWith('#/admin')) {
    return <AdminDashboard />;
  }

  // Route: Order Confirmation
  if (currentRoute.startsWith('#/order-confirmation')) {
    return (
      <div className="min-h-screen flex flex-col bg-[#fafaf9]">
        <Header />
        <main className="flex-1">
          <OrderConfirmation />
        </main>
        <Footer />
        <LegalModal />
      </div>
    );
  }

  // Default Route: Storefront
  return (
    <div className="min-h-screen flex flex-col bg-[#fafaf9] text-gray-900">
      <Header />

      <main className="flex-1">
        {/* Product Hero Section */}
        <section className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8 sm:py-14">
          <div className="grid grid-cols-1 lg:grid-cols-12 gap-8 lg:gap-14 items-start">
            {/* Left: Interactive 3D Tilt Mug Viewer */}
            <div className="lg:col-span-7 flex justify-center sticky top-24">
              <TiltMugViewer />
            </div>

            {/* Right: Product Purchasing & Specs */}
            <div className="lg:col-span-5">
              <ProductDetails />
            </div>
          </div>
        </section>

        {/* FAQ Section */}
        <FAQ />
      </main>

      {/* Standard Footer */}
      <Footer />

      {/* Slide-over Cart & Legal Modals */}
      <CartDrawer />
      <LegalModal />

      {/* Floating Toast Notification */}
      {toastMessage && (
        <div className="fixed bottom-6 right-6 z-50 bg-neutral-900 text-white text-xs font-bold px-4 py-3 rounded-2xl shadow-xl flex items-center gap-2 animate-bounce">
          <Check className="w-4 h-4 text-emerald-400" />
          <span>{toastMessage}</span>
        </div>
      )}
    </div>
  );
};
